// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable no-invalid-position-at-import-rule */
:host {
  /* Fonts */
  --ima-font-sans: ui-sans-serif, system-ui, -apple-system, blinkmacsystemfont, 'Segoe UI', roboto, 'Helvetica Neue', arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  --ima-font-mono: ui-monospace, sfmono-regular, menlo, monaco, consolas, 'Liberation Mono', 'Courier New', monospace;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 20000000;
  font-family: var(--ima-font-sans);
}
[data-ima-error-overlay] {
  -moz-tab-size: 2;
    -o-tab-size: 2;
       tab-size: 2;
  -webkit-font-smoothing: auto;
}
/* These styles are injected to the shadow dom of ima-error-overlay */
.ima-overlay {
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
}
@-webkit-keyframes fadeInDown {
  0% {
    -webkit-transform: translateY(-5px);
            transform: translateY(-5px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    opacity: 1;
  }
}
@keyframes fadeInDown {
  0% {
    -webkit-transform: translateY(-5px);
            transform: translateY(-5px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    opacity: 1;
  }
}
@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.ima-overlay--animate .ima-overlay__backdrop {
  -webkit-animation: fadeIn 0.15s ease-out;
          animation: fadeIn 0.15s ease-out;
}
.ima-overlay--animate .ima-overlay__foreground {
  -webkit-animation: fadeInDown 0.15s ease-out;
          animation: fadeInDown 0.15s ease-out;
}
.ima-overlay__backdrop {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  width: 100vw;
  height: 100%;
  background: rgba(60, 60, 60, 0.35);
  backdrop-filter: blur(25px);
}
.ima-overlay__foreground {
  position: relative;
  z-index: 10;
  margin: 30px auto;
  padding: 10px;
}
.ima-overlay__content {
  margin: 0 auto;
  border-radius: 3px;
  border-top: 4px solid;
  padding: 30px;
  max-width: 860px;
  background: white;
  -webkit-box-shadow: rgba(149, 157, 165, 0.3) 0 8px 24px;
          box-shadow: rgba(149, 157, 165, 0.3) 0 8px 24px;
}
.ima-overlay__content--compile {
  border-color: #fde68a;
}
.ima-overlay__content--runtime {
  border-color: #ef4444;
}
.ima-header {
  position: relative;
  font-family: var(--ima-font-mono);
}
.ima-header__type {
  display: inline-block;
  padding: 3px 6px;
  font-size: 12px;
  font-weight: 500;
  color: #e2e8f0;
  text-transform: capitalize;
  background-color: #334155;
}
.ima-header__type--compile {
  color: #a16207;
  background-color: #fde68a;
}
.ima-header__type--runtime {
  color: white;
  background-color: #ef4444;
}
.ima-header__meta {
  margin: 8px 0 16px;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: -1.5px;
  color: #ef4444;
  white-space: pre-line;
}
.ima-header__name {
  font-weight: 600;
}
.ima-runtime-error > * {
  margin-bottom: 40px;
}
.ima-runtime-error > *:last-child {
  margin-bottom: 0;
}
.ima-runtime-error__expand-wrapper {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: center;
      justify-content: center;
  -ms-flex-align: center;
      align-items: center;
}
.ima-runtime-error__expand-button {
  border: none;
  padding: 14px 20px;
  font-family: var(--ima-font-mono);
  font-size: 14px;
  line-height: 14px;
  background-color: #e2e8f0;
  -webkit-transition: all 0.15s ease-in-out;
  transition: all 0.15s ease-in-out;
  cursor: pointer;
}
.ima-runtime-error__expand-button:hover {
  background-color: #cbd5e1;
}
.ima-runtime-error__expand-button:active {
  -webkit-transform: scale(0.95);
          transform: scale(0.95);
}
.ima-runtime-error__number {
  text-decoration: underline;
}
.ima-frame {
  border-radius: 5px;
  overflow: hidden;
  color: #f8fafc;
  background-color: #334155;
  -webkit-box-shadow: rgba(51, 65, 85, 0.5) 0 10px 15px -3px, rgba(51, 65, 85, 0.5) 0 4px 6px -4px;
          box-shadow: rgba(51, 65, 85, 0.5) 0 10px 15px -3px, rgba(51, 65, 85, 0.5) 0 4px 6px -4px;
}
.ima-frame__code {
  overflow-y: auto;
  font-size: 14px;
  line-height: 24px;
}
.ima-frame__line {
  display: -ms-flexbox;
  display: flex;
  border-left: 4px solid transparent;
  -ms-flex-align: center;
      align-items: center;
  font-family: var(--ima-font-mono);
}
.ima-frame__line--highlight {
  border-color: #f43f5e;
  background-color: rgba(244, 63, 94, 0.2);
}
.ima-frame__line-number {
  margin-right: 12px;
  border-right: 2px solid rgba(71, 85, 105, 0.75);
  padding: 0 12px;
  color: #94a3b8;
}
.ima-frame__error {
  display: -ms-flexbox;
  display: flex;
  padding: 24px 12px;
  -ms-flex-pack: center;
      justify-content: center;
  -ms-flex-align: center;
      align-items: center;
  font-family: var(--ima-font-mono);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: #94a3b8;
}
.ima-frame__error-icon {
  margin-right: 8px;
  color: #fb7185;
}
.ima-frame-header {
  display: -ms-flexbox;
  display: flex;
  border-bottom: 1px solid #475569;
  -ms-flex-pack: justify;
      justify-content: space-between;
  -ms-flex-align: center;
      align-items: center;
  font-family: var(--ima-font-mono);
  -webkit-box-shadow: rgba(30, 41, 59, 0.25) 0 8px 12px;
          box-shadow: rgba(30, 41, 59, 0.25) 0 8px 12px;
}
.ima-frame-header__tab {
  display: -ms-flexbox;
  display: flex;
  border-right: 1px solid #475569;
  border-bottom: 2px solid #06b6d4;
  padding: 10px 16px;
}
.ima-frame-header__file-info {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-positive: 0;
      flex-grow: 0;
  -ms-flex-direction: column;
      flex-direction: column;
  -ms-flex-pack: center;
      justify-content: center;
  -ms-flex-align: start;
      align-items: flex-start;
}
.ima-frame-header__method-name {
  display: -ms-inline-flexbox;
  display: inline-flex;
  -ms-flex-align: center;
      align-items: center;
  font-size: 14px;
  line-height: 22px;
  white-space: nowrap;
}
.ima-frame-header__file-uri {
  font-size: 12px;
  line-height: 16px;
  color: #94a3b8;
  white-space: nowrap;
}
.ima-frame-header__actions {
  display: -ms-flexbox;
  display: flex;
  margin: 0 12px;
  -ms-flex-pack: center;
      justify-content: center;
  -ms-flex-align: center;
      align-items: center;
}
.ima-frame-header__button {
  display: -ms-flexbox;
  display: flex;
  margin: 0;
  margin-left: 4px;
  border: none;
  padding: 10px;
  -ms-flex-pack: center;
      justify-content: center;
  -ms-flex-align: center;
      align-items: center;
  color: #64748b;
  background: none;
  -webkit-transition: all 0.15s ease-in-out;
  transition: all 0.15s ease-in-out;
  cursor: pointer;
}
@-webkit-keyframes pulse {
  from {
    -webkit-transform: scale(0.9);
            transform: scale(0.9);
  }
  to {
    -webkit-transform: scale(1.1);
            transform: scale(1.1);
  }
}
@keyframes pulse {
  from {
    -webkit-transform: scale(0.9);
            transform: scale(0.9);
  }
  to {
    -webkit-transform: scale(1.1);
            transform: scale(1.1);
  }
}
.ima-frame-header__button:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}
.ima-frame-header__button:hover:not(.ima-frame-header__button:disabled) {
  color: #cbd5e1;
}
.ima-frame-header__button:active:not(.ima-frame-header__button:disabled) {
  -webkit-transform: scale(0.9);
          transform: scale(0.9);
}
.ima-frame-header__button--green {
  color: #10b981;
}
.ima-frame-header__button--pulse {
  -webkit-animation: pulse 0.5s infinite ease-in-out alternate;
          animation: pulse 0.5s infinite ease-in-out alternate;
}
.ima-frame-header__error-icon {
  margin-right: 4px;
  color: #fb7185;
}
.token.comment,
.token.prolog,
.token.doctype,
.token.cdata {
  color: #94a3b8;
}
.token.punctuation {
  color: #cbd5e1;
}
.token.namespace {
  opacity: 0.7;
}
.token.property,
.token.tag,
.token.constant,
.token.symbol,
.token.deleted {
  color: #f472b6;
}
.token.boolean,
.token.number {
  color: #a5b4fc;
}
.token.selector,
.token.attr-name,
.token.string,
.token.char,
.token.builtin,
.token.inserted {
  color: #34d399;
}
.token.operator,
.token.entity,
.token.url,
.language-css .token.string,
.style .token.string,
.token.variable {
  color: #cbd5e1;
}
.token.atrule,
.token.attr-value,
.token.function,
.token.class-name {
  color: #c084fc;
}
.token.keyword {
  color: #67e8f9;
}
.token.regex,
.token.important {
  color: #fbbf24;
}
.token.important,
.token.bold {
  font-weight: bold;
}
.token.italic {
  font-style: italic;
}
.token.entity {
  cursor: help;
}
.ima-icon {
  display: inline-block;
}
.ima-icon--size-xs {
  width: 12px;
  height: 12px;
}
.ima-icon--size-sm {
  width: 16px;
  height: 16px;
}
.ima-icon--size-md {
  width: 20px;
  height: 20px;
}
.ima-icon--size-lg {
  width: 24px;
  height: 24px;
}
.ima-close {
  position: absolute;
  right: 0;
  top: 0;
  margin: 0;
  border: none;
  padding: 0;
  color: #475569;
  background: none;
  -webkit-transition: all 0.15s ease-in-out;
  transition: all 0.15s ease-in-out;
  cursor: pointer;
}
.ima-close:hover {
  color: #0f172a;
}
.ima-close:active {
  -webkit-transform: scale(0.9);
          transform: scale(0.9);
}
.ima-error-params {
  margin-bottom: 20px;
  border-radius: 5px;
  overflow: hidden;
  color: #f8fafc;
  background-color: #334155;
  -webkit-box-shadow: rgba(51, 65, 85, 0.5) 0 10px 15px -3px, rgba(51, 65, 85, 0.5) 0 4px 6px -4px;
          box-shadow: rgba(51, 65, 85, 0.5) 0 10px 15px -3px, rgba(51, 65, 85, 0.5) 0 4px 6px -4px;
}
.ima-error-params__title {
  display: -ms-flexbox;
  display: flex;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  border: none;
  border-bottom: 1px solid #475569;
  padding: 12px 16px;
  width: 100%;
  -ms-flex-pack: justify;
      justify-content: space-between;
  -ms-flex-align: center;
      align-items: center;
  font-family: var(--ima-font-mono);
  font-size: 14px;
  line-height: 20px;
  -webkit-box-shadow: rgba(30, 41, 59, 0.25) 0 8px 12px;
          box-shadow: rgba(30, 41, 59, 0.25) 0 8px 12px;
}
.ima-error-params__separator {
  margin-left: 18px;
  width: 2px;
  height: 20px;
  background-color: #475569;
}
.ima-error-params__button {
  display: -ms-inline-flexbox;
  display: inline-flex;
  margin-left: 10px;
  border: none;
  padding: 0 6px;
  -ms-flex-pack: center;
      justify-content: center;
  -ms-flex-align: center;
      align-items: center;
  color: #f8fafc;
  background-color: #334155;
  -webkit-transform: scale(0.9);
          transform: scale(0.9);
  cursor: pointer;
}
.ima-error-params__button:hover .ima-error-params__icon {
  color: #cbd5e1;
}
.ima-error-params__icon {
  color: #64748b;
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
  -webkit-transition: all 0.15s ease-in-out;
  transition: all 0.15s ease-in-out;
}
.ima-error-params__size {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
      align-items: center;
  color: #64748b;
}
.ima-error-params__json-tree {
  padding: 10px;
  font-family: var(--ima-font-mono);
  font-size: 13px;
  line-height: 19px;
}
.ima-error-params--hidden .ima-error-params__icon {
  -webkit-transform: rotate(0);
          transform: rotate(0);
}
`, "",{"version":3,"sources":["webpack://./src/app.less","webpack://./src/components/overlay/overlay.less","webpack://./src/components/header/header.less","webpack://./src/components/runtimeError/runtimeError.less","webpack://./src/components/frame/frame.less","webpack://./src/components/frame/frameHeader.less","webpack://./src/components/frame/prismjs.less","webpack://./src/components/icon/icon.less","webpack://./src/components/close/close.less","webpack://./src/components/errorParams/errorParams.less"],"names":[],"mappings":"AAAA,yDAAyD;AACzD;EACE,UAAU;EACV,gOAAA;EAIA,mHAAA;EAIA,eAAA;EACA,OAAA;EACA,MAAA;EACA,iBAAA;EAEA,iCAAA;AANF;AASA;EACE,gBAAA;IAAA,cAAA;OAAA,WAAA;EAEA,4BAAA;AARF;AACA,qEAAqE;ACfrE;EACE,YAAA;EACA,aAAA;EAEA,gBAAA;ADgBF;ACdE;EACE;IACE,mCAAA;YAAA,2BAAA;IACA,UAAA;EDgBJ;ECbE;IACE,gCAAA;YAAA,wBAAA;IACA,UAAA;EDeJ;AACF;ACxBE;EACE;IACE,mCAAA;YAAA,2BAAA;IACA,UAAA;EDgBJ;ECbE;IACE,gCAAA;YAAA,wBAAA;IACA,UAAA;EDeJ;AACF;ACZE;EACE;IACE,UAAA;EDcJ;ECXE;IACE,UAAA;EDaJ;AACF;ACpBE;EACE;IACE,UAAA;EDcJ;ECXE;IACE,UAAA;EDaJ;AACF;ACTI;EAEI,wCAAA;UAAA,gCAAA;ADUR;ACZI;EAMI,4CAAA;UAAA,oCAAA;ADSR;ACHI;EACE,kBAAA;EACA,OAAA;EAEA,MAAA;EACA,UAAA;EAEA,YAAA;EACA,YAAA;EAEA,kCAAA;EAEA,2BAAA;ADCN;ACEI;EACE,kBAAA;EACA,WAAA;EAEA,iBAAA;EAEA,aAAA;ADFN;ACKI;EACE,cAAA;EAEA,kBAAA;EAEA,qBAAA;EAEA,aAAA;EACA,gBAAA;EAEA,iBAAA;EAEA,uDAAA;UAAA,+CAAA;ADRN;ACWQ;EACE,qBAAA;ADTV;ACYQ;EACE,qBAAA;ADVV;AE3EA;EACE,kBAAA;EAEA,iCAAA;AF4EF;AEzEI;EACE,qBAAA;EAEA,gBAAA;EAEA,eAAA;EACA,gBAAA;EACA,cAAA;EAEA,0BAAA;EAEA,yBAAA;AFuEN;AEpEQ;EACE,cAAA;EAEA,yBAAA;AFqEV;AElEQ;EACE,YAAA;EAEA,yBAAA;AFmEV;AE9DI;EACE,kBAAA;EAEA,eAAA;EACA,iBAAA;EAEA,sBAAA;EACA,cAAA;EAEA,qBAAA;AF6DN;AE1DI;EACE,gBAAA;AF4DN;AG1GE;EACE,mBAAA;AH4GJ;AG1GI;EACE,gBAAA;AH4GN;AGvGI;EACE,oBAAA;EAAA,aAAA;EAEA,qBAAA;MAAA,uBAAA;EACA,sBAAA;MAAA,mBAAA;AHwGN;AGrGI;EACE,YAAA;EAEA,kBAAA;EAEA,iCAAA;EAEA,eAAA;EACA,iBAAA;EAEA,yBAAA;EAEA,yCAAA;EAAA,iCAAA;EAEA,eAAA;AHiGN;AG/FM;EACE,yBAAA;AHiGR;AG9FM;EACE,8BAAA;UAAA,sBAAA;AHgGR;AG5FI;EACE,0BAAA;AH8FN;AIzIA;EACE,kBAAA;EACA,gBAAA;EAEA,cAAA;EAEA,yBAAA;EAEA,gGAAA;UAAA,wFAAA;AJwIF;AInII;EACE,gBAAA;EAEA,eAAA;EACA,iBAAA;AJoIN;AIjII;EACE,oBAAA;EAAA,aAAA;EAEA,kCAAA;EAEA,sBAAA;MAAA,mBAAA;EAEA,iCAAA;AJgIN;AI7HQ;EACE,qBAAA;EAEA,wCAAA;AJ8HV;AIzHI;EACE,kBAAA;EACA,+CAAA;EAEA,eAAA;EAEA,cAAA;AJyHN;AItHI;EACE,oBAAA;EAAA,aAAA;EAEA,kBAAA;EAEA,qBAAA;MAAA,uBAAA;EAEA,sBAAA;MAAA,mBAAA;EAEA,iCAAA;EAEA,eAAA;EACA,iBAAA;EAEA,kBAAA;EAEA,cAAA;AJiHN;AI9GI;EACE,iBAAA;EAEA,cAAA;AJ+GN;AKpLA;EACE,oBAAA;EAAA,aAAA;EAEA,gCAAA;EAEA,sBAAA;MAAA,8BAAA;EAEA,sBAAA;MAAA,mBAAA;EAEA,iCAAA;EAEA,qDAAA;UAAA,6CAAA;ALiLF;AK9KI;EACE,oBAAA;EAAA,aAAA;EAEA,+BAAA;EAEA,gCAAA;EAEA,kBAAA;AL6KN;AK1KI;EACE,oBAAA;EAAA,aAAA;EAEA,oBAAA;MAAA,YAAA;EAEA,0BAAA;MAAA,sBAAA;EAEA,qBAAA;MAAA,uBAAA;EACA,qBAAA;MAAA,uBAAA;ALyKN;AKtKI;EACE,2BAAA;EAAA,oBAAA;EAEA,sBAAA;MAAA,mBAAA;EAEA,eAAA;EACA,iBAAA;EACA,mBAAA;ALsKN;AKnKI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EAEA,mBAAA;ALoKN;AKjKI;EACE,oBAAA;EAAA,aAAA;EAEA,cAAA;EAEA,qBAAA;MAAA,uBAAA;EAEA,sBAAA;MAAA,mBAAA;ALgKN;AK7JI;EACE,oBAAA;EAAA,aAAA;EAEA,SAAA;EAEA,gBAAA;EACA,YAAA;EACA,aAAA;EAEA,qBAAA;MAAA,uBAAA;EACA,sBAAA;MAAA,mBAAA;EAEA,cAAA;EAEA,gBAAA;EAEA,yCAAA;EAAA,iCAAA;EAEA,eAAA;ALwJN;AKtJM;EACE;IACE,6BAAA;YAAA,qBAAA;ELwJR;EKrJM;IACE,6BAAA;YAAA,qBAAA;ELuJR;AACF;AK9JM;EACE;IACE,6BAAA;YAAA,qBAAA;ELwJR;EKrJM;IACE,6BAAA;YAAA,qBAAA;ELuJR;AACF;AKpJM;EACE,mBAAA;EACA,YAAA;ALsJR;AKnJM;EACE,cAAA;ALqJR;AKlJM;EACE,6BAAA;UAAA,qBAAA;ALoJR;AKhJQ;EACE,cAAA;ALkJV;AK/IQ;EACE,4DAAA;UAAA,oDAAA;ALiJV;AK5II;EACE,iBAAA;EAEA,cAAA;AL6IN;AMrQA;;;;EAIE,cAAA;ANuQF;AMpQA;EACE,cAAA;ANsQF;AMnQA;EACE,YAAA;ANqQF;AMlQA;;;;;EAKE,cAAA;ANoQF;AMjQA;;EAEE,cAAA;ANmQF;AMhQA;;;;;;EAME,cAAA;ANkQF;AM/PA;;;;;;EAME,cAAA;ANiQF;AM9PA;;;;EAIE,cAAA;ANgQF;AM7PA;EACE,cAAA;AN+PF;AM5PA;;EAEE,cAAA;AN8PF;AM3PA;;EAEE,iBAAA;AN6PF;AM1PA;EACE,kBAAA;AN4PF;AMzPA;EACE,YAAA;AN2PF;AOnUA;EACE,qBAAA;APqUF;AOhUQ;EACE,WAAA;EACA,YAAA;APkUV;AO/TQ;EACE,WAAA;EACA,YAAA;APiUV;AO9TQ;EACE,WAAA;EACA,YAAA;APgUV;AO7TQ;EACE,WAAA;EACA,YAAA;AP+TV;AQtVA;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EAEA,SAAA;EAEA,YAAA;EAEA,UAAA;EAEA,cAAA;EAEA,gBAAA;EAEA,yCAAA;EAAA,iCAAA;EAEA,eAAA;ARiVF;AQ/UE;EACE,cAAA;ARiVJ;AQ9UE;EACE,6BAAA;UAAA,qBAAA;ARgVJ;ASxWA;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,cAAA;EAEA,yBAAA;EAEA,gGAAA;UAAA,wFAAA;ATuWF;ASlWI;EACE,oBAAA;EAAA,aAAA;EAEA,8BAAA;UAAA,sBAAA;EAEA,YAAA;EACA,gCAAA;EACA,kBAAA;EAEA,WAAA;EAEA,sBAAA;MAAA,8BAAA;EAEA,sBAAA;MAAA,mBAAA;EAEA,iCAAA;EACA,eAAA;EAEA,iBAAA;EAEA,qDAAA;UAAA,6CAAA;AT4VN;ASzVI;EACE,iBAAA;EACA,UAAA;EACA,YAAA;EAEA,yBAAA;AT0VN;ASvVI;EACE,2BAAA;EAAA,oBAAA;EAEA,iBAAA;EACA,YAAA;EACA,cAAA;EAEA,qBAAA;MAAA,uBAAA;EAEA,sBAAA;MAAA,mBAAA;EAEA,cAAA;EAEA,yBAAA;EAEA,6BAAA;UAAA,qBAAA;EACA,eAAA;ATmVN;ASjVM;EAEI,cAAA;ATkVV;AS7UI;EACE,cAAA;EAEA,gCAAA;UAAA,wBAAA;EACA,yCAAA;EAAA,iCAAA;AT8UN;AS3UI;EACE,oBAAA;EAAA,aAAA;EAEA,sBAAA;MAAA,mBAAA;EAEA,cAAA;AT2UN;ASxUI;EACE,aAAA;EAEA,iCAAA;EACA,eAAA;EACA,iBAAA;ATyUN;ASpUI;EAEI,4BAAA;UAAA,oBAAA;ATqUR","sourcesContent":["/* stylelint-disable no-invalid-position-at-import-rule */\n:host {\n  /* Fonts */\n  --ima-font-sans:\n    ui-sans-serif, system-ui, -apple-system, blinkmacsystemfont, 'Segoe UI',\n    roboto, 'Helvetica Neue', arial, 'Noto Sans', sans-serif,\n    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';\n  --ima-font-mono:\n    ui-monospace, sfmono-regular, menlo, monaco, consolas, 'Liberation Mono',\n    'Courier New', monospace;\n\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 20000000;\n\n  font-family: var(--ima-font-sans);\n}\n\n[data-ima-error-overlay] {\n  tab-size: 2;\n\n  -webkit-font-smoothing: auto;\n}\n\n/* These styles are injected to the shadow dom of ima-error-overlay */\n@import './components/overlay/overlay.less';\n@import './components/header/header.less';\n@import './components/runtimeError/runtimeError.less';\n@import './components/frame/frame.less';\n@import './components/frame/frameHeader.less';\n@import './components/frame/prismjs.less';\n@import './components/icon/icon.less';\n@import './components/close/close.less';\n@import './components/errorParams/errorParams.less';\n",".ima-overlay {\n  width: 100vw;\n  height: 100vh;\n\n  overflow-y: auto;\n\n  @keyframes fadeInDown {\n    0% {\n      transform: translateY(-5px);\n      opacity: 0;\n    }\n\n    100% {\n      transform: translateY(0);\n      opacity: 1;\n    }\n  }\n\n  @keyframes fadeIn {\n    0% {\n      opacity: 0;\n    }\n\n    100% {\n      opacity: 1;\n    }\n  }\n\n  &-- {\n    &animate {\n      .ima-overlay__backdrop {\n        animation: fadeIn 0.15s ease-out;\n      }\n\n      .ima-overlay__foreground {\n        animation: fadeInDown 0.15s ease-out;\n      }\n    }\n  }\n\n  &__ {\n    &backdrop {\n      position: absolute;\n      left: 0;\n\n      top: 0;\n      z-index: 1;\n\n      width: 100vw;\n      height: 100%;\n\n      background: rgba(60, 60, 60, 0.35);\n\n      backdrop-filter: blur(25px);\n    }\n\n    &foreground {\n      position: relative;\n      z-index: 10;\n\n      margin: 30px auto;\n\n      padding: 10px;\n    }\n\n    &content {\n      margin: 0 auto;\n\n      border-radius: 3px;\n\n      border-top: 4px solid;\n\n      padding: 30px;\n      max-width: 860px;\n\n      background: white;\n\n      box-shadow: rgba(149, 157, 165, 0.3) 0 8px 24px;\n\n      &-- {\n        &compile {\n          border-color: #fde68a;\n        }\n\n        &runtime {\n          border-color: #ef4444;\n        }\n      }\n    }\n  }\n}\n",".ima-header {\n  position: relative;\n\n  font-family: var(--ima-font-mono);\n\n  &__ {\n    &type {\n      display: inline-block;\n\n      padding: 3px 6px;\n\n      font-size: 12px;\n      font-weight: 500;\n      color: #e2e8f0;\n\n      text-transform: capitalize;\n\n      background-color: #334155;\n\n      &-- {\n        &compile {\n          color: #a16207;\n\n          background-color: #fde68a;\n        }\n\n        &runtime {\n          color: white;\n\n          background-color: #ef4444;\n        }\n      }\n    }\n\n    &meta {\n      margin: 8px 0 16px;\n\n      font-size: 20px;\n      line-height: 28px;\n\n      letter-spacing: -1.5px;\n      color: #ef4444;\n\n      white-space: pre-line;\n    }\n\n    &name {\n      font-weight: 600;\n    }\n  }\n}\n",".ima-runtime-error {\n  & > * {\n    margin-bottom: 40px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  &__ {\n    &expand-wrapper {\n      display: flex;\n\n      justify-content: center;\n      align-items: center;\n    }\n\n    &expand-button {\n      border: none;\n\n      padding: 14px 20px;\n\n      font-family: var(--ima-font-mono);\n\n      font-size: 14px;\n      line-height: 14px;\n\n      background-color: #e2e8f0;\n\n      transition: all 0.15s ease-in-out;\n\n      cursor: pointer;\n\n      &:hover {\n        background-color: #cbd5e1;\n      }\n\n      &:active {\n        transform: scale(0.95);\n      }\n    }\n\n    &number {\n      text-decoration: underline;\n    }\n  }\n}\n",".ima-frame {\n  border-radius: 5px;\n  overflow: hidden;\n\n  color: #f8fafc;\n\n  background-color: #334155;\n\n  box-shadow:\n    rgba(51, 65, 85, 0.5) 0 10px 15px -3px,\n    rgba(51, 65, 85, 0.5) 0 4px 6px -4px;\n\n  &__ {\n    &code {\n      overflow-y: auto;\n\n      font-size: 14px;\n      line-height: 24px;\n    }\n\n    &line {\n      display: flex;\n\n      border-left: 4px solid transparent;\n\n      align-items: center;\n\n      font-family: var(--ima-font-mono);\n\n      &-- {\n        &highlight {\n          border-color: #f43f5e;\n\n          background-color: rgba(244, 63, 94, 0.2);\n        }\n      }\n    }\n\n    &line-number {\n      margin-right: 12px;\n      border-right: 2px solid rgba(71, 85, 105, 0.75);\n\n      padding: 0 12px;\n\n      color: #94a3b8;\n    }\n\n    &error {\n      display: flex;\n\n      padding: 24px 12px;\n\n      justify-content: center;\n\n      align-items: center;\n\n      font-family: var(--ima-font-mono);\n\n      font-size: 12px;\n      line-height: 16px;\n\n      text-align: center;\n\n      color: #94a3b8;\n    }\n\n    &error-icon {\n      margin-right: 8px;\n\n      color: #fb7185;\n    }\n  }\n}\n",".ima-frame-header {\n  display: flex;\n\n  border-bottom: 1px solid #475569;\n\n  justify-content: space-between;\n\n  align-items: center;\n\n  font-family: var(--ima-font-mono);\n\n  box-shadow: rgba(30, 41, 59, 0.25) 0 8px 12px;\n\n  &__ {\n    &tab {\n      display: flex;\n\n      border-right: 1px solid #475569;\n\n      border-bottom: 2px solid #06b6d4;\n\n      padding: 10px 16px;\n    }\n\n    &file-info {\n      display: flex;\n\n      flex-grow: 0;\n\n      flex-direction: column;\n\n      justify-content: center;\n      align-items: flex-start;\n    }\n\n    &method-name {\n      display: inline-flex;\n\n      align-items: center;\n\n      font-size: 14px;\n      line-height: 22px;\n      white-space: nowrap;\n    }\n\n    &file-uri {\n      font-size: 12px;\n      line-height: 16px;\n      color: #94a3b8;\n\n      white-space: nowrap;\n    }\n\n    &actions {\n      display: flex;\n\n      margin: 0 12px;\n\n      justify-content: center;\n\n      align-items: center;\n    }\n\n    &button {\n      display: flex;\n\n      margin: 0;\n\n      margin-left: 4px;\n      border: none;\n      padding: 10px;\n\n      justify-content: center;\n      align-items: center;\n\n      color: #64748b;\n\n      background: none;\n\n      transition: all 0.15s ease-in-out;\n\n      cursor: pointer;\n\n      @keyframes pulse {\n        from {\n          transform: scale(0.9);\n        }\n\n        to {\n          transform: scale(1.1);\n        }\n      }\n\n      &:disabled {\n        cursor: not-allowed;\n        opacity: 0.7;\n      }\n\n      &:hover:not(&:disabled) {\n        color: #cbd5e1;\n      }\n\n      &:active:not(&:disabled) {\n        transform: scale(0.9);\n      }\n\n      &-- {\n        &green {\n          color: #10b981;\n        }\n\n        &pulse {\n          animation: pulse 0.5s infinite ease-in-out alternate;\n        }\n      }\n    }\n\n    &error-icon {\n      margin-right: 4px;\n\n      color: #fb7185;\n    }\n  }\n}\n",".token.comment,\n.token.prolog,\n.token.doctype,\n.token.cdata {\n  color: #94a3b8;\n}\n\n.token.punctuation {\n  color: #cbd5e1;\n}\n\n.token.namespace {\n  opacity: 0.7;\n}\n\n.token.property,\n.token.tag,\n.token.constant,\n.token.symbol,\n.token.deleted {\n  color: #f472b6;\n}\n\n.token.boolean,\n.token.number {\n  color: #a5b4fc;\n}\n\n.token.selector,\n.token.attr-name,\n.token.string,\n.token.char,\n.token.builtin,\n.token.inserted {\n  color: #34d399;\n}\n\n.token.operator,\n.token.entity,\n.token.url,\n.language-css .token.string,\n.style .token.string,\n.token.variable {\n  color: #cbd5e1;\n}\n\n.token.atrule,\n.token.attr-value,\n.token.function,\n.token.class-name {\n  color: #c084fc;\n}\n\n.token.keyword {\n  color: #67e8f9;\n}\n\n.token.regex,\n.token.important {\n  color: #fbbf24;\n}\n\n.token.important,\n.token.bold {\n  font-weight: bold;\n}\n\n.token.italic {\n  font-style: italic;\n}\n\n.token.entity {\n  cursor: help;\n}\n",".ima-icon {\n  display: inline-block;\n\n  &-- {\n    &size {\n      &- {\n        &xs {\n          width: 12px;\n          height: 12px;\n        }\n\n        &sm {\n          width: 16px;\n          height: 16px;\n        }\n\n        &md {\n          width: 20px;\n          height: 20px;\n        }\n\n        &lg {\n          width: 24px;\n          height: 24px;\n        }\n      }\n    }\n  }\n}\n",".ima-close {\n  position: absolute;\n  right: 0;\n  top: 0;\n\n  margin: 0;\n\n  border: none;\n\n  padding: 0;\n\n  color: #475569;\n\n  background: none;\n\n  transition: all 0.15s ease-in-out;\n\n  cursor: pointer;\n\n  &:hover {\n    color: #0f172a;\n  }\n\n  &:active {\n    transform: scale(0.9);\n  }\n}\n",".ima-error-params {\n  margin-bottom: 20px;\n  border-radius: 5px;\n  overflow: hidden;\n\n  color: #f8fafc;\n\n  background-color: #334155;\n\n  box-shadow:\n    rgba(51, 65, 85, 0.5) 0 10px 15px -3px,\n    rgba(51, 65, 85, 0.5) 0 4px 6px -4px;\n\n  &__ {\n    &title {\n      display: flex;\n\n      box-sizing: border-box;\n\n      border: none;\n      border-bottom: 1px solid #475569;\n      padding: 12px 16px;\n\n      width: 100%;\n\n      justify-content: space-between;\n\n      align-items: center;\n\n      font-family: var(--ima-font-mono);\n      font-size: 14px;\n\n      line-height: 20px;\n\n      box-shadow: rgba(30, 41, 59, 0.25) 0 8px 12px;\n    }\n\n    &separator {\n      margin-left: 18px;\n      width: 2px;\n      height: 20px;\n\n      background-color: #475569;\n    }\n\n    &button {\n      display: inline-flex;\n\n      margin-left: 10px;\n      border: none;\n      padding: 0 6px;\n\n      justify-content: center;\n\n      align-items: center;\n\n      color: #f8fafc;\n\n      background-color: #334155;\n\n      transform: scale(0.9);\n      cursor: pointer;\n\n      &:hover {\n        .ima-error-params__icon {\n          color: #cbd5e1;\n        }\n      }\n    }\n\n    &icon {\n      color: #64748b;\n\n      transform: rotate(90deg);\n      transition: all 0.15s ease-in-out;\n    }\n\n    &size {\n      display: flex;\n\n      align-items: center;\n\n      color: #64748b;\n    }\n\n    &json-tree {\n      padding: 10px;\n\n      font-family: var(--ima-font-mono);\n      font-size: 13px;\n      line-height: 19px;\n    }\n  }\n\n  &-- {\n    &hidden {\n      .ima-error-params__icon {\n        transform: rotate(0);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
